import { z } from 'zod'

export const STRATALYST_PROJECT_MODULES_READ_CONTRACT_VERSION = '1.0.0' as const

const optionalQueryString = z.preprocess(
  (value) => (typeof value === 'string' ? value : undefined),
  z.string().optional(),
)

export const stratalystProjectModulesReadQuerySchema = z.object({
  orgId: optionalQueryString,
  org_id: optionalQueryString,
}).passthrough()

export const stratalystProjectModulesReadEvidenceSchema = z.object({
  sourceOfTruth: z.literal('DB1'),
  tablesRead: z.array(z.string()),
  projection: z.literal('stratalyst-consulting-forms-admin'),
  rawPayloadReturned: z.literal(false),
}).passthrough()

export const stratalystProjectModulesReadSideEffectsSchema = z.object({
  db1Read: z.boolean(),
  db1Written: z.boolean(),
  uploadTouched: z.literal(false),
  r2Touched: z.literal(false),
  billingTouched: z.literal(false),
  eventEmitted: z.literal(false),
  llmTouched: z.literal(false),
  queuePublished: z.literal(false),
  db2Touched: z.literal(false),
  deployLiveTraffic: z.literal(false),
  destructiveCleanup: z.literal(false),
}).passthrough()

export const stratalystProjectModuleStatusSchema = z.enum(['draft', 'published', 'archived'])

export const stratalystProjectModuleSummarySchema = z.object({
  id: z.string().min(1),
  moduleId: z.string().min(1),
  name: z.string(),
  moduleStatus: stratalystProjectModuleStatusSchema,
  orgAssigned: z.boolean(),
  createdAt: z.string(),
}).passthrough()

export const stratalystAssignableModuleSummarySchema = z.object({
  moduleId: z.string().min(1),
  name: z.string(),
  status: stratalystProjectModuleStatusSchema,
}).passthrough()

export const stratalystProjectModulesResponseSchema = z.object({
  contract_version: z.literal(STRATALYST_PROJECT_MODULES_READ_CONTRACT_VERSION),
  modules: z.array(stratalystProjectModuleSummarySchema),
  readEvidence: stratalystProjectModulesReadEvidenceSchema,
  sideEffects: stratalystProjectModulesReadSideEffectsSchema,
}).passthrough()

export const stratalystAssignableModulesResponseSchema = z.object({
  contract_version: z.literal(STRATALYST_PROJECT_MODULES_READ_CONTRACT_VERSION),
  modules: z.array(stratalystAssignableModuleSummarySchema),
  readEvidence: stratalystProjectModulesReadEvidenceSchema,
  sideEffects: stratalystProjectModulesReadSideEffectsSchema,
}).passthrough()

export type StratalystProjectModulesReadQuery = z.infer<typeof stratalystProjectModulesReadQuerySchema>
export type StratalystProjectModulesReadEvidence = z.infer<typeof stratalystProjectModulesReadEvidenceSchema>
export type StratalystProjectModulesReadSideEffects = z.infer<typeof stratalystProjectModulesReadSideEffectsSchema>
export type StratalystProjectModuleStatus = z.infer<typeof stratalystProjectModuleStatusSchema>
export type StratalystProjectModuleSummary = z.infer<typeof stratalystProjectModuleSummarySchema>
export type StratalystAssignableModuleSummary = z.infer<typeof stratalystAssignableModuleSummarySchema>
export type StratalystProjectModulesResponse = z.infer<typeof stratalystProjectModulesResponseSchema>
export type StratalystAssignableModulesResponse = z.infer<typeof stratalystAssignableModulesResponseSchema>
